import List from "@/components/list";
import "@/pages/user/table.scss";
import { CONVENE_CLASSES } from "../../../utils/constants";

const Table = (args) => {
  const { listeners } = args;
  const moveGroupUser = listeners["moveGroupUser"] || function () { };
  const setLeaderUser = listeners["setLeaderUser"] || function () { };
  const changeRoom = listeners["changeRoom"] || function () { };
  const RCSelectionChange = listeners["selection-change"] || function () { };

  const { groupSourceType = 1, isOnline = 0, isParty = 1, trainTypeName = "" } = args.props
  // const conveneTrainClasses = ["党校专题研讨班", "轮训班", "网院专题研习班"]

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    let flag = item.groupName === "未分组"
    const dealConf = [
      ["ic-yidong-normal", "移动学员", () => moveGroupUser(item), ""],
    ];
    if (Number(groupSourceType) === 1) {
      dealConf.push([
        flag ? "icon-leaderUser-disable" : (item.groupPost === '召集人' ? "icon-delete-group" : "icon-leaderUser"),
        CONVENE_CLASSES.includes(trainTypeName) ? (item.groupPost === '召集人' ? "取消召集人" : "设为召集人") : "设为组长",
        () => {
          if (flag) return
          setLeaderUser(item);
        },
      ])
    }
    dealConf.push(["iconfont icxiugaifangjianhao iconfont-adapt", "修改房间号", () => changeRoom(item), "enroll:update"],);

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]} ></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const DeptName = ({props: {vo}}) => {
    const item = vo.row;
    return (
      <div class='user-status'>
        {item.deptName}
        { item.graduationLineName ? <div class='blue_tag'>{item.graduationLineName}</div> : null }
      </div>
    )
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "所在分组",
      prop: "groupName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "姓名",
      prop: "userName",
      width: "80",
      showOverflowTooltip: true,
    },
    {
      label: "组内职务",
      prop: "groupPost",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "150",
      align: "center",
      // showOverflowTooltip: true,
      render: (vo) => <DeptName vo={vo} />,
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "150",
      showOverflowTooltip: true,
    },
    {
      label: "职务层次",
      prop: "positionName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "职级",
      prop: "positionLevelName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "性别",
      prop: "sexName",
      width: "80",
      showOverflowTooltip: true,
    },
    {
      label: "出生年月",
      prop: "birthday",
      width: "80",
      showOverflowTooltip: true,
    },
    {
      label: "政治面貌",
      prop: "politicsName",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "学历",
      prop: "educationName",
      width: "120",
      showOverflowTooltip: true,
    },
  ];

  // if (conveneTrainClasses.includes(trainTypeName)) {
    AccountTableConfig.splice(6, 0, {
      label: "房间号",
      prop: "roomNumber",
      width: "100",
      showOverflowTooltip: true,
    })
  // }

  if (isOnline === 0 && isParty == 1 && groupSourceType == 1) {
    AccountTableConfig.push({
      label: "党校同步状态",
      prop: "groupPushStatusName",
      width: "100",
      showOverflowTooltip: true,
    })
    AccountTableConfig.push({
      label: "上次同步时间	",
      prop: "groupPushTime",
      width: "160",
      showOverflowTooltip: true,
    })

  }
  if (groupSourceType === 1) {
    AccountTableConfig.push({
      label: "操作",
      fixed: "right",
      width: "100",
      render: (vo) => <Deal vo={vo} />,
    })
  }
  return <List {...args} talbeCols={AccountTableConfig} onSelectionChange={RCSelectionChange} />;
};

export default Table;
